import { FormattedDate, FormattedNumber } from 'components/shared/Intl';
import { FC } from 'react';

import type { ProductSummaryCellMetadata, ProductSummaryScheduleRow, ScheduleCellType } from './Schedule.model';

export function fieldForType(type: ScheduleCellType) {
  switch (type) {
    case 'Date':
      return DateCell;
    case 'FixedUnit':
      return FixedUnitCell;
    default:
      throw new Error(`type '${type} is not handled`) as never;
  }
}

export interface ScheduleCellProps {
  scheduleRow: ProductSummaryScheduleRow;
  cellMetadata: ProductSummaryCellMetadata;
}

const DateCell: FC<ScheduleCellProps> = ({ scheduleRow, cellMetadata }) => {
  const cellValue = scheduleRow[cellMetadata.id] as string;
  return <FormattedDate value={new Date(cellValue!)} year="numeric" month="short" day="2-digit" />;
};

const FixedUnitCell: FC<ScheduleCellProps> = ({ scheduleRow, cellMetadata }) => {
  const cellValue = scheduleRow[cellMetadata.id] as number;
  const cellUnit = cellMetadata.unit;
  return cellValue === undefined ? null : (
    <p className="text-large fw-light m-0">
      <FormattedNumber value={cellValue} /> {cellUnit}
    </p>
  );
};
